import { TutorialButton } from "@components/index";

export const DesktopPageTitle = ({
  title,
  tutorialNames,
  faqCategory = [],
  variant = "light",
}: {
  title: string;
  tutorialNames?: string[];
  faqCategory?: string[];
  variant?: "light" | "dark";
}) => (
  <div className="flex items-center gap-x-4 px-10">
    <h1 className="text-600 font-bold text-white-100">{title}</h1>
    {!!tutorialNames?.length && (
      <TutorialButton
        tutorialNames={tutorialNames}
        faqCategory={faqCategory}
        variant={variant}
      />
    )}
  </div>
);
